<template>
  <v-content
    id="pages"
  >
    <router-view />
  </v-content>
</template>

<script>
  export default {
    name: 'PagesCoreView',
  }
</script>

<style lang="sass">
  #pages
    > .v-content__wrap > .v-image
      padding-top: 64px
      padding-bottom: 88px

    .v-responsive__sizer
      display: none

    .v-image--md
      padding: 188px 0

    .v-image--sm
      padding: 96px 0 188px 0
</style>
